import { createSlice } from "@reduxjs/toolkit";

export const tycSlice = createSlice({
  name: 'tyc',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startTyC: (state) => { state.isLoading = true },
    setTyC: (state, { payload: { data, error }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});


export const { startTyC, setTyC } = tycSlice.actions;
